import React, { useContext, useEffect, useRef, useState } from 'react'

import "./styles.scss"
import Button from '../Button'
import Card from '../Card/Card'
import { showToast, startLoading, stopLoading } from '../../services/common-service'
import BlipPortalToastTypes from '../../constants/blip-portal-toast-types'
import Alert from '../Alert'
import { v4 as uuid } from 'uuid';
import { AppContext, useApp } from '../../contexts/AppContext'
import { useSharkPlugins } from '../../contexts/SharkPluginsProvider'
import { useBlip } from '../../contexts/BlipContext'
import api from '../../factory/api'
import { timeSince } from '../../services/format'
import { useHistory } from 'react-router-dom';
import TicketsCard from '../TicketCard'
import Pagination from '../Pagination'

export default function TicketsList({
    setTicketOpened
}) {
    const { t, appInfo } = useContext(AppContext)
    const history = useHistory();

    const { getTicket, setTicket } = useBlip()

    const { sendAction } = useSharkPlugins()
    const { config } = useApp()

    const [isLoading, setIsLoading] = useState(true)
    const [tickets, setTickets] = useState([])
    const [totalSize, setTotalSize] = useState(0)
    const [isModalOpened, setIsModalOpened] = useState(null)
    const [isModalImportOpened, setIsModalImportOpened] = useState(null)

    const [alertOpened, setAlertOpened] = useState(false)
    const [alert, setAlert] = useState({})

    const [page, setPage] = useState(1)
    const pageSize = 10

    useEffect(() => {
        if (appInfo?.tenantId)
            start()
    }, [appInfo, page])

    const start = async () => {
        try {
            startLoading()
            setIsLoading(() => true)

            let { data } = await api.get("/tickets/client", {
                params: {
                    page
                },
                headers: {
                    tenantId: appInfo.tenantId
                }
            })

            let { totalSize, tickets = [] } = data

            // console.log("tickets", tickets)

            // sendAction({
            //     type: "information",
            //     action: "ticketsQuantity",
            //     value: tickets.length
            // })

            setTickets(tickets)
            setTotalSize(totalSize)
        } catch (error) {
            console.error(error)
        } finally {
            stopLoading()
            setIsLoading(() => false)
        }
    }


    const remove = async (_id) => {
        try {
            startLoading()

            let ticketsManagerPlugin = []

            try {
                let response = await getTicket(config.ticketName)

                ticketsManagerPlugin = response?.tickets
            } catch (error) {
                if (typeof error == "string") {
                    error = JSON.parse(error)
                    if (error?.message && typeof error.message == "string")
                        error.message = JSON.parse(error.message)
                }

                // console.log("error", error)

                if (error?.message?.reason?.code == 67) {
                    ticketsManagerPlugin = []
                } else
                    throw error
            }

            // console.log(config.ticketName, ticketsManagerPlugin)
            let newTicketsManagerPlugin = ticketsManagerPlugin.filter(ticket => ticket._id != _id)

            await setTicket(config.ticketName, { tickets: newTicketsManagerPlugin })

            setTickets(newTicketsManagerPlugin)
        } catch (error) {
            // console.log(JSON.parse(error))
            // console.error(error)
            showToast({
                type: BlipPortalToastTypes.DANGER,
                message: error?.message || "Ocorreu um erro"
            });
        } finally {
            stopLoading()
            setAlertOpened(false)
        }
    }

    return (
        <>
            <div className="tickets-list mt3 mb5">
                <div className="header mb3">
                    <h3>{totalSize > 0 ? `${totalSize} ${t('texts.ticket')}${tickets.length > 1 ? "s" : ""}` : ""}</h3>

                    <div style={{ display: 'flex', gap: 10 }}>
                        {config?.showImportTicket &&
                            <Button
                                text={t('button.import')}
                                variant="ghost"
                                arrow={false}
                                disabled={false}
                                onClick={() => setIsModalImportOpened(true)}
                            />
                        }

                        {config?.showCreateTicket &&
                            <Button
                                text={t('button.createTicket')}
                                variant="primary"
                                arrow={false}
                                disabled={false}
                                onClick={() => setIsModalOpened({})}
                            />
                        }

                        {/* <Button
                            text={"Cadastrar Documentação"}
                            variant="primary"
                            arrow={false}
                            disabled={false}
                            onClick={() => setIsModalOpened({})}
                        /> */}
                    </div>
                </div>

                {isLoading ?
                    <div style={{ textAlign: "center" }}>
                        <bds-typo variant="fs-20" bold="light">Carregando...</bds-typo>
                    </div> :
                    tickets.length == 0 ?
                        <div style={{ textAlign: "center" }}>
                            <bds-typo variant="fs-20" bold="light">{t('messages.noTicketRegistered')}</bds-typo>
                        </div> :
                        <></>
                }

                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    {tickets.map((ticket, index) =>
                        <TicketsCard
                            key={index}
                            ticket={ticket}
                        />
                    )}

                    <div className="center" style={{ marginTop: 20 }}>
                        <Pagination
                            pages={pageSize ? Math.ceil(+(totalSize / pageSize)) : 1}
                            onPaginationChange={({ page }) => setPage(page || 1)}
                        />
                    </div>
                </div>
            </div>

            <Alert
                opened={alertOpened}
                setAlert={setAlert}
                {...alert}
            />
        </>
    )
}